const accordion = document.querySelectorAll('.product-accordion');
const accordionTitle = document.querySelectorAll('.product-accordion-title');
const accordionIcon = document.querySelectorAll('.product-accordion-icon');

accordionTitle.forEach((title, index) => {
  title.addEventListener('click', () => {
    const content = title.nextElementSibling;
    const isOpen = content.classList.contains('active');
    if (isOpen) {
      content.classList.remove('active');
      accordionIcon[index].innerHTML = `
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.875 11.7321V0H7.125V11.7321H4.875ZM0 6.9375V4.82143H12V6.9375H0Z" fill="#979797" />
        </svg>`;
    } else {
      content.classList.add('active');
      accordionIcon[index].innerHTML = `
        <svg width="9" height="3" viewBox="0 0 9 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2.77695V0H9V2.77695H0Z" fill="#444444" />
        </svg>`;
    }
    });
});